import React from 'react';
import { Input } from '@economic/taco';
import { useCurrentLocale } from '@economic/react-app';
import number from '../../util/utilities/number';

export default function AmountInput({ onChange: handleChange, value, ...props }) {
    const locale = useCurrentLocale();
    const decimalSeparator = locale.formatting.numberDecimalSeparator;
    const acceptedPrefixes = ['+', '-'];
    const prependEqualOnExpressions = (anExpresison: string) =>
        anExpresison > '' && anExpresison.trim() > '' && acceptedPrefixes.indexOf(anExpresison[0]) > -1
            ? '=' + anExpresison.trim()
            : anExpresison;
    const [internalValue, setInternalValue] = React.useState<any>(number.format(value, decimalSeparator));

    React.useEffect(() => {
        const nextValue = value !== '' ? number.parseExpression(value, decimalSeparator) : '';
        if (internalValue !== nextValue) {
            setInternalValue(nextValue);
        }
    }, [value]);

    /**
     * This is used for updating the parent of value changes without waiting for the onBlur event.
     */
    const onLiveChange = (amount: string) => {
        if (props.onLiveChange instanceof Function) {
            const value =
                amount !== ''
                    ? number.parse(number.parseExpression(prependEqualOnExpressions(amount), decimalSeparator))
                    : undefined;
            props.onLiveChange(value);
        }
    };

    return (
        <Input
            {...props}
            className="text-right"
            onChange={event => {
                setInternalValue(event.target.value);
                onLiveChange(event.target.value);
            }}
            onBlur={event => {
                event.persist();
                const value =
                    event.target.value !== ''
                        ? number.parse(number.parseExpression(prependEqualOnExpressions(event.target.value), decimalSeparator))
                        : undefined;
                setInternalValue(number.format(value, decimalSeparator));
                handleChange(value);
                // must be called to correctly trigger final-form touched/visited state updates used by validation
                // Ensure form validation happens after `handleChange`
                setTimeout(() => props.onBlur?.(event), 0);
            }}
            style={{ width: '140px' }}
            value={internalValue}
        />
    );
}
